export default __webpack_public_path__ + "static/media/delete_item.df4a597e.svg";